import React from 'react'
import ApplicationTypeListPage from './ApplicationTypeListPage'

const applicationTypeRoutes = [
  {
    breadcrumb: 'Application Type',
    path: '',
    element: <ApplicationTypeListPage />,
    children: [],
  },
]

export default applicationTypeRoutes
